/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetApprovalCompetencyRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
